import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';

export default function ScreenRender(props) {
    const { setNodeData, nodeData } = props;
    const [screens, ] = useState(["certislogo", "smoking", "bicycle", "scooter", "maintenance", "patrolling"]);
    const [selected_screen, setSelectedScreen] = useState(nodeData.type === "screen"? nodeData.selectedScreen: screens[0])
    setNodeData({
        type: "screen",
        selectedScreen: selected_screen
    })
    const handleChange = (event) => {
        setSelectedScreen(event.target.value)
        setNodeData({
            type: "screen",
            selectedScreen: event.target.value
        })
    }

    return(
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextField
        select
        id="outlined-required"
        label="Screen"
        defaultValue={selected_screen}
        value={selected_screen}
        name="robot_actions"
        style={{width: "100%"}}
        onChange={handleChange}
      >
      {screens.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
      </Grid>)
}